import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../../ui';
import { StyledCardButton, StyledButtonWrapper } from './AssetCard.style';
export function AssetActionButtons({ color, type, buttons, onClick, }) {
    return (_jsx(StyledButtonWrapper, { children: buttons.map(({ title, name, icon }) => (_jsx(StyledCardButton, { title: title, buttonStyle: type, onClick: onClick(name), children: _jsx(Icon, { color: color, name: icon, size: 'Small' }) }, `action-${title}-${name}`))) }));
}
//# sourceMappingURL=AssetActionButtons.js.map